const TTL = 5 * 60 * 1000;
export const CATALOGS_KEY = "cachedExploreCatalogs";
export const PROJECTS_CATALOGS_KEY = "cachedProjectsCatalogs";
export const RAW_PROJECTS_CATALOGS_KEY = "cachedRawProjectsCatalogs";

export function getCached(key: string) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed.timestamp || !parsed.catalogs) return null;
    if (Date.now() - parsed.timestamp > TTL) return null;
    return parsed.catalogs;
  } catch {
    return null;
  }
}

export function setCached(key: string, catalogs: Record<string, string[] | Record<string, string>[]>) {
  localStorage.setItem(
    key,
    JSON.stringify({
      catalogs,
      timestamp: Date.now(),
    })
  );
}

export function clearCached(key: string) {
  localStorage.removeItem(key);
}
